import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppUtilityService } from '../services/AppUtilityService';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(private apUtil: AppUtilityService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const restrictedRoles: string[] = route.data['restrictedRoles'];

    if(restrictedRoles){
      const user = this.apUtil.persistenceService().get('clientDetails');
      if (user !== undefined && restrictedRoles.includes(user.role)) {
        this.apUtil.errorService().showErrorToast("You don't have persmission to view this page!")
        return false;
      }else{
        return true;
      }
    }else{
      return this.apUtil.persistenceService().get('clientDetails') !== undefined;
    }

  }
}
